module.exports = __webpack_public_path__ + "static/img/wangchuangcode.575b6c64.png";